import React from 'react';

// Components
import WpButton from 'Wpds/components/button/WpButton';
import { WpModal, WpModalHeader, WpModalBody, WpModalFooter } from 'Wpds/components/modal';

const DEFAULT_OK_BUTTON_LABEL = 'Ok';

type Props = {
  isOpen: boolean;
  onToggle: Function;
  title: string;
  message: string;
  children?: React.ReactNode;
  okButtonLabel?: string;
  onOkClick?: () => void;
};

function MessageModal({
  isOpen,
  onToggle,
  title,
  message,
  children,
  okButtonLabel = DEFAULT_OK_BUTTON_LABEL,
  onOkClick,
}: Props) {
  const body = children || message;

  const handleOkClick = () => {
    if (onOkClick) onOkClick();
    else onToggle();
  };

  return (
    <WpModal isOpen={isOpen} size="sm" onToggle={() => onToggle()} dismissOnBackdrop={false}>
      <WpModalHeader>{title}</WpModalHeader>
      <WpModalBody>{body}</WpModalBody>
      <WpModalFooter>
        <WpButton qaTest="message-modal-ook-button" onClick={handleOkClick}>
          {okButtonLabel}
        </WpButton>
      </WpModalFooter>
    </WpModal>
  );
}

export default MessageModal;
